module.exports = __webpack_public_path__ + "img/pGcashW.031f36fb.svg";